import React from "react";
import { TableBody as MuiTableBody, TableBodyProps as MuiTableBodyProps } from "@mui/material";
import { Box } from "./Box";

type TableBodyProps = MuiTableBodyProps & {};

export const TableBody = React.forwardRef<HTMLTableSectionElement, TableBodyProps>(({ children, ...rest }, ref) => {
  return (
    <MuiTableBody ref={ref} {...rest}>
      {children}
    </MuiTableBody>
  );
});
